export class NeqRangeModel {
    start = 0;
    end = 0;
    total = 0;
    ranges: number[];
}
